import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPluginComponent } from "./med-icon-plugin.component";

@NgModule({
  declarations: [
    MedIconPluginComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPluginComponent,
  ],
})
export class MedIconPluginModule { }
